import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import PageBanner from '../../common/PageBanner/PageBanner';

import {
  DEFAULT_IMAGE_ALT_TEXT,
  DEV_BASE_URL,
  IS_DEV,
  PROD_BASE_URL,
  UPLOADS_FOLDER,
} from '../../config/constants/contants';

import styles from './Projects.module.scss';
import commons from '../../shared/styles/common.module.scss';
import ProjectItem from './components/ProjectItem';
import PROJECTS from '../../collections/projects/projects';

const Projects = () => {
  const { t } = useTranslation();
  const imagesURL = IS_DEV ? DEV_BASE_URL : PROD_BASE_URL;

  return (
    <div>
      <PageBanner
        imageSrc={`${imagesURL}${UPLOADS_FOLDER}/cetatea-fagaras-sala-tronului.jpeg`}
        imageText={DEFAULT_IMAGE_ALT_TEXT}
      />
      <div className={classNames(styles.projectsContainer, commons.container)}>
        <div className={styles.headingWrapper}>
          <h3 className={commons.subSectionHeading}>{t('pages.projects')}</h3>
          <hr className={styles.headingLine} />
        </div>
        <div className={styles.projectsList}>
          {PROJECTS.map((project) => (
            <ProjectItem key={project.id} project={project} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
